module.exports = __webpack_public_path__ + "img/5d2098d.svg";